import apiClient from '../../lib/axios';

export const fetchAccountCodes = async ({
  page = 1,
  pageSize = 10,
  code,
  isActive,
  description,
} = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (code) params.append('code', code);
  if (description) params.append('description', description);
  const { data } = await apiClient.get(`/api/account-codes?${params.toString()}`);
  return data;
};

export const fetchActiveAccountCodes = async () => {
  const { data } = await apiClient.get('/api/account-codes/active');
  return data;
};

export const createAccountCode = async (payload) => {
  const { data } = await apiClient.post('/api/account-codes', payload);
  return data;
};

export const updateAccountCode = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/account-codes/${id}`, payload);
  return data;
};

export const deleteAccountCode = async (id) => {
  const { data } = await apiClient.delete(`/api/account-codes/${id}`);
  return data;
};

export const previewAccountCodesCSV = async (csvContent) => {
  const { data } = await apiClient.post('/api/account-codes/upload-csv/preview', {
    csvContent,
  });
  return data;
};

export const uploadAccountCodesCSV = async (csvContent) => {
  const { data } = await apiClient.post('/api/account-codes/upload-csv', {
    csvContent,
  });
  return data;
};

export default fetchAccountCodes;
